import React from 'react';
import { Container } from 'react-bootstrap';
import ContactSection from './section';

export const Contact: React.FC = () => (
    <Container>
        <ContactSection />
    </Container>
);
